module.exports = __webpack_public_path__ + "static/media/strengths-weaknesses.90ae8d2f.jpg";